import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgTableLayout = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 25"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.75 4.625A2.25 2.25 0 0 1 21 6.875v11.25a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18.125V6.875a2.25 2.25 0 0 1 2.25-2.25zm0 1.688H5.25a.56.56 0 0 0-.562.562v2.25h14.625v-2.25a.563.563 0 0 0-.563-.562M5.25 18.688h2.813v-7.875H4.687v7.312c0 .31.252.563.563.563m4.5 0h9c.31 0 .563-.254.563-.563v-7.312H9.75z"
    }));
export default SvgTableLayout;
